/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    byId: {},
    allIds: [],
    byCode: {},
    allCodes: [],
}

const AdminFeaturesSlice = createAppSlice({
    name: 'gdl/adminFeatures',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        createAdminFeature: create.asyncThunk(
            async (adminFeature, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.adminFeatures(), { body: adminFeature, method: 'POST' })
                    toast.success('Fonctionnalité créée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'une fonctionnalité')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        updateAdminFeature: create.asyncThunk(
            async (adminFeature, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.adminFeatures(), { body: adminFeature, method: 'PUT' })
                    toast.success('Fonctionnalité modifiée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification d\'une fonctionnalité')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        deleteAdminFeature: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.adminFeature(id), { method: 'DELETE' })
                    toast.success('Fonctionnalité supprimée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'une fonctionnalité')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        fetchAdminFeatures: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.gdl.adminFeatures())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des fonctionnalités')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    const byId = keyBy(action.payload, 'id')
                    state.byId = byId
                    state.allIds = action.payload.map(af => af.id)
                    const byCode = keyBy(action.payload, 'code')
                    state.byCode = byCode
                    state.allCodes = action.payload.map(af => af.code)
                },
                options: {
                    condition: (_, { getState }) => {
                        const { gdl } = getState()
                        return gdl.adminFeatures.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            }
        ),
    }),
    selectors: {
        selectAdminFeatures: (state) => state.allIds.map(id => state.byId[id]),
    },
})

export const { fetchAdminFeatures, createAdminFeature, updateAdminFeature, deleteAdminFeature } = AdminFeaturesSlice.actions
export const { selectAdminFeatures } = AdminFeaturesSlice.getSelectors((state) => state.gdl.adminFeatures)
export default AdminFeaturesSlice